import {
    useCallback, useRef,
    useState,
} from 'react'
import {
    noop,
} from 'lodash'
import {
    TableFilterParams,
} from 'app/types/common.types'

import TableActionsContext, {
    TableActionsContextValue,
} from './TableActionsContext'

const useCreateTableActionsStore = (): TableActionsContextValue => {
    const [
        bulkUploadData,
        setBulkUploadDataState,
    ] = useState<TableFilterParams | null>(null)

    const invalidateTableDataRef = useRef<() => void>(noop)

    const setBulkUploadData = useCallback((data: TableFilterParams | null) => {
        setBulkUploadDataState(data)
    }, [])

    return {
        bulkUploadData,
        setBulkUploadData,
        invalidateTableDataRef,
    }
}

const TableActionsProvider = ({
    children,
}: Readonly<{
    children: JSX.Element | JSX.Element[],
}>) => {
    const value = useCreateTableActionsStore()

    return (
        <TableActionsContext.Provider value={value}>
            {children}
        </TableActionsContext.Provider>
    )
}

export default TableActionsProvider
